import { useParams } from "react-router-dom";

import { getAvailableTabs, resolveTabRoute, usePreviousTab } from "@lib/logic";
import { getIsHMEnabledAndIntegrationEnabled, getIsOccupancyEnabled, useAppSelector } from "@lib/store";
import { useFeatureToggle } from "@hooks";

import { haNSession } from "./state/session/haNSession";

export const useAvailableTabs = () => {
  const { WorkspacesOnHereAndNow } = useFeatureToggle();
  const meetingsCalendar = useAppSelector(getIsHMEnabledAndIntegrationEnabled);
  const occupancy = useAppSelector(getIsOccupancyEnabled);

  return getAvailableTabs({ meetingsCalendar, occupancy, workspacesOnHaN: !!WorkspacesOnHereAndNow });
};

export const useHaNTabRoute = () => {
  const { tab } = useParams();
  const availableTabs = useAvailableTabs();
  const previousTab = usePreviousTab(haNSession);

  return resolveTabRoute(tab, availableTabs, previousTab);
};
